export default __webpack_public_path__ + "static/media/checkmark.3af74ea3.svg";